import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UploadFileComponent } from 'src/app/components/upload-file/upload-file.component';

interface UploadDialogData {
  courseItemId: number;
  courseId: number;
  courseName: string;
  requestId: number;
  entityId: number;
}

@Component({
  selector: 'app-upload-documents-modal',
  templateUrl: './upload-documents-modal.component.html',
  styleUrls: ['./upload-documents-modal.component.scss'],
})
export class UploadDocumentsModalComponent {
  @ViewChild('uploader', { static: false }) uploader!: UploadFileComponent;

  courseItemId: number;
  courseId: number;
  courseName: string;
  requestId: number;
   entityId: number;

  constructor(
    public dialogRef: MatDialogRef<UploadDocumentsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UploadDialogData
  ) {
    console.log('UploadDocumentsModalComponent data:', data);
    this.courseItemId = data.courseItemId;
    this.courseId = data.courseId;
    this.courseName = data.courseName;
    this.requestId = data.requestId;
    this.entityId = data.entityId;
  }

  hasFilesToUpload(): boolean {
    return this.uploader?.hasFilesToUpload() || false;
  }

  onUpload(): void {
    if (this.uploader && this.hasFilesToUpload()) {
      this.uploader.triggerUpload();
    }
  }

  onUploadComplete(): void {
    this.dialogRef.close('uploaded');
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}